import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { safeReturnTo } from '@/core/auth';
import { LoginPage } from '@/modules/identity/public';

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(undefined),
  }),
  // Já autenticado: volta para onde ia. `href`, não `to`, porque o destino
  // pode carregar query string (/cursos?status=draft).
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) throw redirect({ href: safeReturnTo(search.redirect), replace: true });
    // Sem redirect para fora no logout, o app continua vivo: o cache do
    // usuário anterior não pode sobreviver para o próximo nesta aba.
    context.queryClient.clear();
  },
  component: () => <LoginPage />,
});
